/* TagsRenderer.js */

"use strict";

class TagsRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("tags-column");
        this._rootElem.component = this._model;

        this._registerListeners();
        this.render();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
        return prom;
    }
    _registerListeners() {
        this._model.on("ValueUpdated", (this._onValueUpdated = this._onValueUpdated.bind(this)));
    }
    _unregisterListeners() {
        this._model.removeAllListeners("ValueUpdated");
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._setValueUpdated(this._model.getValue());
            resolve();
        });
        return prom;
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    _onValueUpdated(newVal) {
        this._setValueUpdated(newVal);
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    _setValueUpdated(newVal) {
        const tagNames = Array.isArray(newVal) ? newVal : [];
        const text = tagNames.join(", ");
        const elem = document.createElement("span");
        elem.textContent = text;
        elem.title = text;
        this._rootElem.innerHTML = "";
        this._rootElem.appendChild(elem);
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = TagsRenderer;
